import { render, staticRenderFns } from "./ProductSalesVolume.vue?vue&type=template&id=2f27dec4&scoped=true&"
import script from "./ProductSalesVolume.vue?vue&type=script&lang=js&"
export * from "./ProductSalesVolume.vue?vue&type=script&lang=js&"
import style0 from "./ProductSalesVolume.vue?vue&type=style&index=0&id=2f27dec4&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f27dec4",
  null
  
)

export default component.exports